'use strict';

exports.__esModule = true;
exports.default = undefined;

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _mozart_ui = require('@pgforsta/mozart_ui');

var _momentTimezone = require('moment-timezone');

var _momentTimezone2 = _interopRequireDefault(_momentTimezone);

var _datePicker = require('material-ui/lib/date-picker/date-picker');

var _datePicker2 = _interopRequireDefault(_datePicker);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DatePickerWeb = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(DatePickerWeb, _Component);

  function DatePickerWeb(props) {
    (0, _classCallCheck3.default)(this, DatePickerWeb);

    var _this = (0, _possibleConstructorReturn3.default)(this, _Component.call(this, props));

    _this.styles = require('./DatePickerWeb.scss');
    _this.state = {
      value: _this.props.value ? _this.props.value : (0, _momentTimezone2.default)(new Date(), 'MM-DD-YYYY').format('MM-DD-YYYY')
    };
    return _this;
  }

  DatePickerWeb.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (nextProps.value) {
      this.setState({ value: nextProps.value });
    }
  };

  DatePickerWeb.prototype.onWebDateChange = function onWebDateChange(event, value) {
    this.props.onChange((0, _momentTimezone2.default)(value, 'MM-DD-YYYY').format('MM-DD-YYYY'));
    this.refs.date_box_web.value = (0, _momentTimezone2.default)(value, 'MM-DD-YYYY').format('MM-DD-YYYY');
  };

  DatePickerWeb.prototype.onDateChange = function onDateChange(value) {
    if (this.isValidDate(value)) {
      this.props.onChange((0, _momentTimezone2.default)(value, 'MM-DD-YYYY').format('MM-DD-YYYY'));
    } else {
      this.refs.date_box_web.value = this.state.value;
    }
    //     if (typeof newvalue[0] === 'undefined') {
    //       this.refs.date_box_web.value = this.state.value;
    //     }
    //     if (!check) {
    //       this.refs.date_box_web.value = value;
    //     }
  };

  DatePickerWeb.prototype.onDateBlur = function onDateBlur(event) {
    var value = event.target.value;
    if (!this.isValidDate(value)) {
      this.props.onChange((0, _momentTimezone2.default)(this.state.value, 'MM-DD-YYYY').format('MM-DD-YYYY'));
    }
  };

  DatePickerWeb.prototype.isValidDate = function isValidDate(date) {
    //     const allowedDateFormats = [
    //       'DD/MM/YYYY', 'DD.MM.YYYY', 'DD-MM-YYYY',
    //       'D/M/YYYY', 'D.M.YYYY', 'D-M-YYYY',
    //       'MM/DD/YYYY', 'MM.DD.YYYY', 'MM-DD-YYYY',
    //       'M/D/YYYY', 'M.D.YYYY', 'M-D-YYYY',
    //       'YYYY/MM/DD', 'YYYY.MM.DD', 'MM-DD-YYYY',
    //       'YYYY/M/D', 'YYYY.M.D', 'YYYY-M-D'
    //     ];
    var allowedDateFormats = ['MM-DD-YYYY'];
    return (0, _momentTimezone2.default)(date, allowedDateFormats, true).isValid();
  };

  DatePickerWeb.prototype.render = function render() {
    var _this2 = this;

    return _react2.default.createElement(
      'div',
      { className: this.styles.slider_container + ' mozart_slider' },
      _react2.default.createElement(_mozart_ui.MozartTextBox, {
        ref: 'date_box_web',
        key: Math.random(),
        id: 'date_box_web',
        className: 'date_range',
        borderInputBox: true,
        hintText: 'MM-DD-YYYY',
        validationBool: false,
        multiLine: false,
        value: (0, _momentTimezone2.default)(this.state.value, 'MM-DD-YYYY').format('MM-DD-YYYY'),
        onChange: this.onDateChange.bind(this),
        onBlur: this.onDateBlur.bind(this),
        icon: _react2.default.createElement('span', { className: 'icon-Calendar', onClick: function onClick() {
            if (_this2.refs.date_picker_web) {
              _this2.refs.date_picker_web.focus();
            }
          } })
      }),
      _react2.default.createElement(_datePicker2.default, {
        ref: 'date_picker_web',
        onChange: this.onWebDateChange.bind(this),
        value: new Date(this.state.value.split('-').join('/')),
        key: Math.random(),
        defaultChecked: false,
        formatDate: function formatDate(date) {
          return (0, _momentTimezone2.default)(date, 'MM-DD-YYYY').format('MM-DD-YYYY');
        },
        mode: 'landscape',
        style: { 'width': '0px', height: '0px' },
        className: this.styles.date_picker_web,
        id: 'date_picker_' + this.state.sequence_no,
        container: 'inline' })
    );
  };

  return DatePickerWeb;
}(_react.Component), _class.propTypes = {
  onChange: _react.PropTypes.func,
  value: _react.PropTypes.obj
}, _temp);
exports.default = DatePickerWeb;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/DatePickerWeb/DatePickerWeb.js
// module id = 2346
// module chunks = 0